<div class="content-body default-height">
    <!-- Breadcrumb  -->
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Back'" (addEvent)="goBackToList($event)"></app-breadcrumb>
    <div class="container-fluid">
      <app-owner-overview (profileDetailsEvent)="getUserDetails($event)"></app-owner-overview>
  
      <div class="tab-content" id="tabContentMyProfileBottom">
        <div class="row">
          <div class="col-xl-12">
            <div class="row">
              <div class="col-xl-4">
                <div class="card">
                  <div class="card-header py-3">
                    <h6 class="card-title">Personal Information</h6>
                    <a *ngIf="checkUserPersonalInfoUpdate" class="btn btn-primary btn-sm"  href="javascript:void(0);" (click)="updateOwner()">Edit</a>
                  </div>
                  <div class="card-body">
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Gender</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold"> {{personal_info?.gender }} </span>
                      </div>
                    </div>
                    
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Current Phone</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{personal_info?.phone }}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Alternate Number</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{personal_info?.alternate_phone }}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Alternate Email</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{personal_info?.alternate_email }}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Date Of Birth</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{personal_info?.dob }}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Marital Status</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{personal_info?.marital_status }}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Pan Number</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{personal_info?.pan }}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Aadhaar Number</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{personal_info?.aadhar }}</span>
                      </div>
                    </div>
                      
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Driving Licence No</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{personal_info?.driving_license }}</span>
                      </div>
                    </div>                  
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-6" *ngIf="userInfo">
                <div class="card">
                  <div class="card-header py-3">
                    <h6 class="card-title">Address information</h6>
                    <a *ngIf="checkUserAddressUpdate" href="javascript:void(0);" class="btn btn-sm btn-primary" (click)="toggleAdress()">Edit</a>
                  </div>
                  <div class="card-body">
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Address</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{userInfo.address_info?.address }}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">City</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{userInfo.address_info?.city }}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">State</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{userInfo.address_info?.state }}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Country</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{userInfo.address_info?.country }}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Zipcode</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{userInfo.address_info?.postal_code }}</span>
                      </div>
                    </div>
                    
                                        
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-6" *ngIf="userInfo">
                <div class="card">
                  <div class="card-header py-3" *ngIf="checkUserWorkView">
                    <h6 class="card-title">Work information</h6>
                    <a *ngIf="checkUserWorkUpdate" href="javascript:void(0);" class="btn btn-sm btn-primary" (click)="toggleWork()">Edit</a>
                  </div>
                  <div class="card-body">
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Company Name</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold"> {{ userInfo.work_info?.company_name}}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Address</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ userInfo.work_info?.company_address}}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Phone</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ userInfo.work_info?.company_phone}}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Email</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ userInfo.work_info?.company_email}}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Designation</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ userInfo.work_info?.designation}}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Department</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ userInfo.work_info?.department}}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Work start date</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ userInfo.work_info?.work_start_date | date:'dd-MM-yyyy'}}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Work end date</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ userInfo.work_info?.work_end_date | date:'dd-MM-yyyy'}}</span>
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Monthly Income</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ userInfo.work_info?.monthly_income}}</span>
                      </div>
                    </div> 
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Work Experience</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ userInfo.work_info?.work_experience}}</span>
                      </div>
                    </div> 
                    <div class="row py-2">
                      <div class="col-6">
                        <span class="fs-13">Work Location</span>
                      </div>
                      <div class="col-6">
                        <span class="fs-13 text-secondary fw-semibold">{{ userInfo.work_info?.work_location}}</span>
                      </div>
                    </div>                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>

<!-- <app-tenant-add (addTenantEvent)="addTenant($event)"></app-tenant-add> -->
<app-owner-add (addOwnerEvent)="ownerUpdatedNotification($event)"></app-owner-add> 

<div #add_address_popup class="offcanvas offcanvas-end customeoff {{ add_address ? 'show':''}}" tabindex="-1" id="add_address" data-bs-backdrop="static">
  <div class="offcanvas-header">
  <h5 class="modal-title" id="#gridSystemModal">Address Information</h5>
    <button type="button" class="btn-close" (click)="addressCancel()">
        <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="offcanvas-body">
    <div class="container-fluid" >
    <form [formGroup]="addressForm" (ngSubmit)="onAddressSubmit()" autocomplete="off"> 
      <div class="row">
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Address<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="HYD" formControlName="address">
            <div *ngIf="addressForm?.get('address')?.invalid && addressForm?.get('address')?.touched" class="required">
              Address is required
          </div>
        </div>	
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Country<span class="text-danger">*</span></label>
            <select2 ngDefaultControl [data]="countries" [templates]="template" class="select2" placeholder="Select country"
              formControlName="country" (update)="getStates()">
              <ng-template #template let-data="data">{{data?.name}}</ng-template>
            </select2>
            <div *ngIf="addressForm?.get('country')?.invalid && addressForm?.get('country')?.touched" class="required">
              Country is required
          </div>
        </div>	
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">State<span class="text-danger">*</span></label>
            <select2 ngDefaultControl [data]="states" [templates]="template"
            class="select2" value="" placeholder="Select state" formControlName="state" (update)="getCities()">
            <ng-template #template let-data="data">{{data?.name}}</ng-template>
            </select2>
            <div *ngIf="addressForm?.get('state')?.invalid && addressForm?.get('state')?.touched" class="required">
              State is required
          </div>
        </div>
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-4" class="form-label">City<span class="text-danger">*</span></label>
            <select2 ngDefaultControl [data]="cities" [templates]="template"
            class="select2" value="" placeholder="Select city" formControlName="city">
            <ng-template #template let-data="data">{{data?.name}}</ng-template>
            </select2>
            <div *ngIf="addressForm?.get('city')?.invalid && addressForm?.get('city')?.touched" class="required">
              City is required
          </div>                                            
        </div>
        <div class="col-xl-6 mb-3">
          <label for="exampleFormControlInput1-3" class="form-label">Zipcode<span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="987456" formControlName="postal_code">  
          <div *ngIf="addressForm?.get('postal_code')?.invalid && addressForm?.get('postal_code')?.touched" class="required">
            Zipcode is required
        </div>                                          
        </div>

    </div>
            <div>
                <button *ngIf="checkUserAddressUpdate" class="btn btn-primary ms-1 me-3" type="submit" [disabled]="addressForm.invalid || loadingService.isLoading()">Save</button>
                <button class="btn btn-danger lightme-1" type="button" (click)="addressCancel()">Cancel</button>
            </div>
    </form>
      </div>
  </div>
</div>		
@if(add_address){
  <div class="offcanvas-backdrop fade show" (click)="toggleAdress()"></div>
}

<div #add_work_popup class="offcanvas offcanvas-end customeoff {{ add_work ? 'show':''}}" tabindex="-1" id="add_work" data-bs-backdrop="static">
  <div class="offcanvas-header">
  <h5 class="modal-title" id="#gridSystemModal">Work Information</h5>
    <button type="button" class="btn-close" (click)="workCancel()">
        <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="offcanvas-body">
    <div class="container-fluid" >
    <form [formGroup]="workForm" (ngSubmit)="onWorkSubmit()" autocomplete="off"> 
      <div class="row">
        <div class="col-xl-6 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Company Name<span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="ABC" formControlName="company_name">
          <div *ngIf="workForm?.get('company_name')?.invalid && workForm?.get('company_name')?.touched" class="required">
            Company name is required
        </div>
      </div>
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Address<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="HYD" formControlName="company_address">
            <div *ngIf="workForm?.get('company_address')?.invalid && workForm?.get('company_address')?.touched" class="required">
              Address is required
          </div>
        </div>
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Phone</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="1234567890" formControlName="company_phone">
        </div>	
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Email</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="abc@mail.com" formControlName="company_email">            
        </div>	
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Designation</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Engineer" formControlName="designation">  
        </div>
        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Department</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="department" formControlName="department">  
        </div>             
      <div class="col-xl-6 mb-3">
        <label for="exampleFormControlInput1-3" class="form-label">Monthly Income</label>
        <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="0" formControlName="monthly_income">                                              
      </div>
      <div class="col-xl-6 mb-3">
        <label for="exampleFormControlInput1-3" class="form-label">Work Start Date</label>
        <input type="date" class="form-control" id="exampleFormControlInput1-3" placeholder="0" formControlName="work_start_date">                                              
      </div>  
      <div class="col-xl-6 mb-3">
        <label for="exampleFormControlInput1-3" class="form-label">Work End Date</label>
        <input type="date" class="form-control" id="exampleFormControlInput1-3" placeholder="0" formControlName="work_end_date" [min]="workForm.get('work_start_date')?.value">
      </div>
      <div class="col-xl-6 mb-3">
        <label for="exampleFormControlInput1-3" class="form-label">Work Experience</label>
        <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="0" formControlName="work_experience">                                              
      </div>
      <div class="col-xl-6 mb-3">
        <label for="exampleFormControlInput1-3" class="form-label">Work Location</label>
        <input type="text" class="form-control" id="exampleFormControlInput1-3" placeholder="0" formControlName="work_location">                                              
      </div>

    </div>
            <div>
                <button *ngIf="checkUserWorkUpdate" class="btn btn-primary ms-1 me-3" type="submit" [disabled]="workForm.invalid || loadingService.isLoading()">Save</button>
                <button class="btn btn-danger lightme-1" type="button" (click)="workCancel()">Cancel</button>
            </div>
    </form>
      </div>
  </div>
</div>		
@if(add_work){
  <div class="offcanvas-backdrop fade show" (click)="toggleAdress()"></div>
}
